import ModelBase from "./shared/model-base.js";

interface ModelAttributes {
  id: string | number;
  name?: string;
  slug?: string;
  initials?: string;
  designation?: string;
  title?: string;
  organization?: string;
  country_id?: string | number;
  photo_url?: string;
  bio?: string;
  ranking?: number;
  is_published?: boolean;
  published_state?: string;
  published_at?: string;
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "leader",
  columns: [
    "id",
    "name",
    "slug",
    "initials",
    "designation",
    "title",
    "organization",
    "country_id",
    "photo_url",
    "bio",
    "ranking",
    "is_published",
    "published_state",
    "published_at",
    "created_at",
  ],
  editColumns: {},
};

export default class Leader extends ModelBase {
  declare id: string | number;
  declare name: string;
  declare slug: string;
  declare initials: string;
  declare designation: string;
  declare title: string;
  declare organization: string;
  declare country_id: string | number;
  declare photo_url: string;
  declare bio: string;
  declare ranking: number;
  declare is_published: boolean;
  declare published_state: string;
  declare published_at: string;
  declare created_at: string;

  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
